import React, { useEffect, useRef, useState } from "react";

import {
    View,
    ScrollView,
    TouchableOpacity
} from "react-native";
import AppTheme from "../../utils/Theme";
import SVGView from "../../utils/SvgView";
import { IcChevronLeft, IcChevronRight } from "../../utils/Icons";
import Style from "../../utils/Style";

interface SuperPowerRowProps {
    containerWidth: number;
    rowWidth: number;
    rowBlocks: React.JSX.Element[]
}

const SuperPowerRow = (props: SuperPowerRowProps) => {

    const appTheme: AppTheme = new AppTheme();

    const { containerWidth, rowWidth, rowBlocks } = props;

    const [rowPosition, setRowPosition] = useState<number>(0);
    let scrollViewRef = useRef<ScrollView>(null);

    useEffect(() => {
        if ((scrollViewRef.current !== undefined) && (scrollViewRef.current !== null)) {
            scrollViewRef.current.scrollTo({ x: rowWidth * rowPosition, y: 0, animated: true });
        }
    }, [rowPosition]);

    const moveScrollViewBackward = () => {
        if (rowPosition > 0) {
            setRowPosition(rowPosition - 1);
        }
    }

    const moveScrollViewForward = () => {
        if (rowPosition < Math.floor(rowBlocks.length / 3)) {
            setRowPosition(rowPosition + 1);
        }
    }

    const moveScrollViewBackwardButton: React.JSX.Element = ((rowBlocks.length > 3) && (rowPosition > 0)) ? <TouchableOpacity onPress={moveScrollViewBackward} style={[Style.shadowed, { width: appTheme.pixelPerfect(25), height: appTheme.pixelPerfect(25), borderRadius: appTheme.pixelPerfect(13), backgroundColor: appTheme.darkBlue, justifyContent: "center", alignItems: "center" }]}>
        <SVGView Component={IcChevronLeft} size={14} color="#FFFFFF" />
    </TouchableOpacity> : <View style={{ width: appTheme.pixelPerfect(25) }} />;
    const moveScrollViewForwardButton: React.JSX.Element = ((rowBlocks.length > 3) && ((rowPosition + 1) < Math.floor(rowBlocks.length / 3))) ? <TouchableOpacity onPress={moveScrollViewForward} style={[Style.shadowed, { width: appTheme.pixelPerfect(25), height: appTheme.pixelPerfect(25), borderRadius: appTheme.pixelPerfect(13), backgroundColor: appTheme.darkBlue, justifyContent: "center", alignItems: "center" }]}>
        <SVGView Component={IcChevronRight} size={14} color="#FFFFFF" />
    </TouchableOpacity> : <View style={{ width: appTheme.pixelPerfect(25) }} />;

    return <View style={{ width: containerWidth, flexDirection: "row", backgroundColor: "#FFFFFF", justifyContent:"space-between", alignItems: "center", paddingHorizontal: appTheme.pixelPerfect(5) }}>
        {moveScrollViewBackwardButton}
        <View style={{ width: rowWidth }}>
            <ScrollView ref={scrollViewRef} horizontal={true} showsHorizontalScrollIndicator={false} pagingEnabled={true} style={{ width: rowWidth, backgroundColor: "#ffffff" }}>
                {rowBlocks}
            </ScrollView>
        </View>
        {moveScrollViewForwardButton}
    </View>
}

export default SuperPowerRow;